import api from "@/api";
import store from "@/store";

const resource = "ei/diario-escolar-aee-acp";

export default {

  getListarAlunos(identificadoraula) {
    return api.get(`${resource}/listar-alunos/${identificadoraula}`);
  },
  postAlunoAula(data) {
    return api.post(`${resource}`, data);
  },
  putAlunoAula(data) {
    return api.put(`${resource}/${data.identificadoraulaalunoatendimentoespecial}`, data);
  },
  deleteAlunoAula(id) {
    return api.delete(`${resource}/${id}`);
  },

};
